import React from 'react';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Card3D from '../ui/Card3D';
import { Service } from '../../types/service';

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const IconComponent = Icons[service.iconName as keyof typeof Icons];

  return (
    <Card3D>
      <div className="bg-white p-8 rounded-2xl shadow-lg h-full">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div 
              className="w-12 h-12 rounded-xl flex items-center justify-center transition-colors duration-300"
              style={{
                backgroundColor: `${service.color}15`,
                color: service.color,
              }}
            >
              {IconComponent && <IconComponent className="w-6 h-6" />}
            </div>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2" style={{ color: service.color }}>
              {service.title}
            </h3>
            <p className="text-gray-600 mb-3">{service.description}</p>
            <div className="flex items-center justify-between">
              <span 
                className="inline-block px-3 py-1 rounded-full text-sm font-medium"
                style={{
                  backgroundColor: `${service.color}15`,
                  color: service.color,
                }}
              >
                {service.highlight}
              </span>
              <Link
                to={service.link}
                className="inline-flex items-center text-sm font-medium transition-colors hover:opacity-80"
                style={{ color: service.color }}
              >
                En savoir plus
                <ArrowRight className="ml-1 w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Card3D>
  );
};

export default ServiceCard;